/* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Dimmer,
  Feed,
  Loader,
  Segment,
} from 'semantic-ui-react';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import ListItem, { ListItemPlaceholder, ListItemEmpty } from '../BookingNote/ListItem';
import { StateAuth } from '../../types';

class List extends Component {
  static propTypes = {
    auth: StateAuth,
    parentType: PropTypes.string,
    parentID: PropTypes.string,
    hasEditAccess: PropTypes.bool, // user's role has edit access from project settings
    isExpanded: PropTypes.bool, // expanded layout mode
    noteEditingID: PropTypes.string, // current note id that is being edited
    noteOnDelete: PropTypes.func, // send note id for delete request
    noteOnEdit: PropTypes.func, // send BookingNotePropTypes object for edit
    requestLoading: PropTypes.bool, // loading state when add, update & delete note request
    onTokenReceived: PropTypes.func,
    t: PropTypes.func,
  };
  static defaultProps = {
    parentID: '',
    noteEditingID: '',
    requestLoading: false,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.internalLoading !== nextProps.requestLoading) {
      return {
        internalLoading: nextProps.requestLoading,
      };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      internalLoading: false,
      data: [],
      dataCurrentPage: 1,
      dataLastPage: 1,
      dataFetching: true,
      dataFirstFetch: false,
      noteDeleting: '',
    };
  }
  async componentDidMount() {
    this.addScrollEvent();
    if (this.props.parentID !== '') {
      await this.fetchNotes();
    }
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.parentID !== this.props.parentID && this.props.parentID !== '') {
      await this.fetchNotes();
    }
  }
  async componentWillUnmount() {
    this.removeScrollEvent();
  }
  setComponentState(state) {
    return new Promise((resolve) => {
      this.setState((prevState) => {
        const nextState = typeof state === 'function' ? state(prevState) : state;
        return nextState;
      }, () => resolve(this.state));
    });
  }
  setDataFetching(dataFetching = false) {
    return new Promise((res) => {
      this.setState({ dataFetching }, () => {
        res(dataFetching);
      });
    });
  }
  getScrollPostion = () => {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      return scrollDiv[0].scrollTop;
    }
    return 0;
  }
  addScrollEvent() {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      scrollDiv[0].addEventListener('scroll', this.handleScroll, false);
    }
  }
  removeScrollEvent() {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      scrollDiv[0].removeEventListener('scroll', this.handleScroll, false);
    }
  }
  scrollToBottom = () => {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      scrollDiv[0].scrollTop = scrollDiv[0].scrollHeight;
    }
  }
  scrollToTop = () => {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      scrollDiv[0].scrollTop = 0;
    }
  }
  scrollToPosition = (position) => {
    const scrollDiv = document.getElementsByClassName('bn-list');
    if (scrollDiv.length > 0) {
      scrollDiv[0].scrollTop = position;
    }
  }
  handleScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const { dataCurrentPage, dataLastPage, dataFetching } = this.state;
    if (
      scrollTop + clientHeight >= scrollHeight - 10 &&
      !dataFetching &&
      (dataCurrentPage + 1) <= dataLastPage
      ) {
      await this.fetchNotes(dataCurrentPage + 1);
    }
  }
  hasManageAccess(bNoteUserID) {
    if (!this.props.hasEditAccess) return false;
    const user = this.props.auth;
    if (user.isAdminBasic || user.isSuperAdmin) {
      return true;
    }
    if (bNoteUserID === user.id) {
      return true;
    }
    return false;
  }
  hasAdminAccess() {
    const user = this.props.auth;
    if (user.isHeadquarters || user.isAdminBasic || user.isSuperAdmin) {
      return true;
    }
    return false;
  }
  async fetchNotes(page = 1, prependNew = false) {
    await this.setDataFetching(true);
    if (page > 1) this.scrollToBottom();
    const { data: currentData, dataCurrentPage } = this.state;
    const { store } = this.context;
    const { t, parentType, parentID } = this.props;
    const query = Object.assign({});
    query.page = page;
    query.parent_type = parentType;
    query.parent_id = parentID;
    let res;
    try {
      res = await store.dispatch(fetchM(`/shared_notes/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setDataFetching(false);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await this.setDataFetching(false);
      await store.dispatch(flashErrorMessage({ message }));
      return;
    }
    const count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
    const limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
    // const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
    const token = res.headers.get('X-Csrf-Token');
    if (token && this.props.onTokenReceived) {
      this.props.onTokenReceived(token);
    }
    const data = await res.json();
    let newData = page === 1 ? data : [...currentData, ...data];
    if (prependNew && currentData && data) {
      newData = [...data.filter(ni => !currentData.some(oi => oi.id === ni.id)), ...currentData]; // prepend new data
    }
    const dataLastPage = limit > 0 ? Math.ceil(count / limit) : 1;
    await this.setComponentState({
      data: newData,
      dataCurrentPage: prependNew ? dataCurrentPage : page,
      dataLastPage,
      dataFetching: false,
      dataFirstFetch: true,
    });
    if (prependNew) this.scrollToTop();
  }
  handleNoteOnDelete = async (bnID, type) => {
    switch (type) {
      default:
      case 'close':
        this.setState({ noteDeleting: '' });
        break;
      case 'open':
        this.setState({ noteDeleting: bnID });
        break;
      case 'delete':
        await this.setComponentState({ noteDeleting: '', internalLoading: true });
        if (this.props.noteOnDelete) await this.props.noteOnDelete(bnID);
        break;
    }
  }
  handleNoteOnEdit = (bNote) => {
    if (this.props.noteOnEdit) this.props.noteOnEdit(bNote);
  }
  deleteStateData = async (bnID) => {
    await this.setComponentState(prevState => ({ internalLoading: false, data: prevState.data.filter(d => d.id !== bnID) }));
  }
  updateStateData = async (bNote) => {
    await this.setComponentState(prevState => ({
      data: prevState.data.map(obj =>
        obj.id === bNote.id ? { ...obj, note: bNote.note, updatedAt: bNote.updatedAt, privacy: bNote.privacy } : obj,
      ),
    }));
  }
  fetchStateData = async (prependNew = true) => {
    if (prependNew && !this.state.dataFirstFetch) return;
    await this.fetchNotes(1, prependNew);
  }
  hasFirstFetchData = async () => this.state.dataFirstFetch
  render() {
    // console.log(this.state.dataFirstFetch)
    const { data: bookingNotes, dataFetching, noteDeleting, internalLoading } = this.state;
    const { parentID, isExpanded, noteEditingID, requestLoading: loading, t } = this.props;
    return (
      <Segment className={`bn-list ${isExpanded ? 'is-expanded' : ''} ${(loading || noteDeleting || noteEditingID) ? 'is-write-mode' : ''}`}>
        <Dimmer
          active={loading || internalLoading}
          inverted
          style={{ zIndex: 20 }}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Feed>
          {parentID !== '' && bookingNotes && bookingNotes.length > 0 ? bookingNotes.map((bNote, idx) => (
            <ListItem
              key={bNote.id}
              listIndex={idx}
              isLastIndex={bookingNotes.length > 1 && bookingNotes.length === (idx + 1)}
              bookingNote={bNote}
              onEdit={this.handleNoteOnEdit}
              onDelete={this.handleNoteOnDelete}
              noteIsDeleting={noteDeleting === bNote.id}
              noteIsEditing={noteEditingID === bNote.id}
              noteIsDisabled={noteEditingID !== '' && noteEditingID !== bNote.id}
              canManage={this.hasManageAccess(bNote.muID)}
              hasAccess={this.hasAdminAccess()}
            />
            )) : (!dataFetching ? <ListItemEmpty t={t} /> : '')}
          {dataFetching ? <ListItemPlaceholder /> : ''}
        </Feed>
      </Segment>
    );
  }
}
export default withTranslation(namespaces, { withRef: true })(List);



// WEBPACK FOOTER //
// ./src/components/SharedNote/List.jsx